var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx } from "react/jsx-runtime";
import { Provider } from '@mindtickle/snowplow-client';
import { useExtendedLogger } from '../Logger';
import { LOGGER_NAME } from './constants';
var withSnowplow = function (_a) {
    var collectorUrl = _a.collectorUrl, namespace = _a.namespace, globalContexts = _a.globalContexts;
    var enhancer = function (Component) { return function (props) {
        var log = useExtendedLogger(LOGGER_NAME);
        log('adding provider with %s as collector url <%s> and namespace <%s>', collectorUrl, namespace);
        return (_jsx(Provider, __assign({ collectorUrl: collectorUrl, namespace: namespace, globalContexts: globalContexts }, { children: _jsx(Component, __assign({}, props), void 0) }), void 0));
    }; };
    return enhancer;
};
export default withSnowplow;
//# sourceMappingURL=withSnowplow.js.map